import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import styled from 'styled-components'
import { Element } from 'react-scroll'
import Hero from './Hero'
import Team from './Team'
import Offices from './Offices'
import Layout from '~shared/Layout'
import ScrollEncourager from '~shared/ScrollEncourager'

// eslint-disable-next-line import/no-unused-modules
export const officeAddressFragment = graphql`
    fragment OfficeAddress on SiteSiteMetadataAboutAddresses {
        id
        mapUrl
        name
        street
        city
        zipcode
        country
        coords {
            lat
            lng
        }
    }
`

// eslint-disable-next-line import/no-unused-modules
export const teamFragment = graphql`
    fragment Team on SiteSiteMetadataAboutTeams {
        id
        members {
            email
            id
            linkedin
            name
            twitter
            website
        }
    }
`

const UnstyledAbout = (props) => {
    const {
        site: {
            siteMetadata: {
                about: { addresses, teams },
            },
        },
    } = useStaticQuery(graphql`
        query Addresses {
            site {
                siteMetadata {
                    about {
                        addresses {
                            ...OfficeAddress
                        }
                        teams {
                            ...Team
                        }
                    }
                }
            }
        }
    `)

    return (
        <Layout {...props} $backgroundColor="white">
            <Hero />
            <Element name={ScrollEncourager.TargetID} />
            <Team teams={teams} />
            <Offices addresses={addresses} />
        </Layout>
    )
}

const About = styled(UnstyledAbout)`
    color: #0c009a;
`

export default About
